import Axios from "../extras/Axios";

export async function getAllUsers() {
    const users = await (await Axios.get('/users')).data;
    return users;
}

export async function updateOneUser(values) {
    const response = await Axios.put('/users', { ...values })
    if (response.status !== 200) return false;
    return true;
}

export async function creteUser(values) {
    const response = await Axios.post('/users', { ...values })
    if (response.status !== 201) return false;
    return true;
}

export async function eliminarUsuario(id) {
    const response = await Axios.delete('/users', { data: { _id: id } })
    if (response.status !== 200) return false;
    return true;
}